import { AuthenticatedRoute } from "@components/AuthenticatedRoute";
import { GoBack } from "@fadmin/components/GoBack";
import { NavItems } from "@helpers/navigation";
import { RoleId } from "@store/generalTypes";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { AdminShell } from "../../../components/AdminShell";
import { ManageNav } from "../components/ManageNav";
import { AdminAssessmentsCompleted } from "./adminAssessmentsCompleted";
import { AdminAssessmentsUpcoming } from "./adminAssessmentsUpcoming";

export const AdminAssessmentsLanding = (): JSX.Element => {
    const { pathname } = useLocation();

    const navigate = useNavigate();

    const handleOnGoBack = (): void => {
        navigate(NavItems.Admin.Manage.Overview.path);
    };

    const routes = (
        <AuthenticatedRoute
            roles={[RoleId.Admin, RoleId.Facilitator]}
            unauthorizePath={NavItems.Admin.Manage.Overview.path}
        >
            <Routes>
                <Route path="*" element={<AdminAssessmentsUpcoming />} />
                <Route
                    path={NavItems.Admin.Assessments.Completed.relativePath}
                    element={<AdminAssessmentsCompleted />}
                />
            </Routes>
        </AuthenticatedRoute>
    );

    const nav =
        pathname === NavItems.Admin.Manage.LocationDetails.path ? (
            <GoBack onClick={handleOnGoBack} title="Back to Upcoming Assessments" />
        ) : (
            <ManageNav />
        );

    return <AdminShell routes={routes} nav={nav} />;
};
